import { useStepsStore } from '../stores/StepsStore';
import VatForm from './fragments/VatForm';

const StepVAT = () => {
  const { error } = useStepsStore();

  return (
    <div className="simple-form">
      <h2 className='ncf-title'>VAT Relief Details</h2>
      <span className='ncf-subtitle'>Please provide the following information for the person who will use our alarm service.</span>
      <VatForm />
      {error !== '' ? <div className="error">{error}</div> : ''}
    </div>
  );
};

export default StepVAT;